export default __webpack_public_path__ + "static/media/hero2.72624808.webp";